export const ADD_SUCCESS = 'Новый уровень добавлен';
export const ADD_ERROR = 'Не удалось добавить уровень';
